import {Pipe, PipeTransform} from "@angular/core";
import {VersionInfo} from "../../../../environments/version-info.model";

@Pipe({
    name: 'versionInfo',
    standalone: false
})
export class VersionInfoPipe implements PipeTransform {

	transform(value: VersionInfo, prefix: string): string {
		return value == null ?
			`${prefix} version unknown` :
			`${prefix}v. ${value.version} build no. ${value.buildNumber} env. ${value.environment}`;
	}
}
